import Link from "next/link";
import Button from "@components/Button";
import IconInfo from "assets/svgs/info.svg";
import { useUser } from "@auth0/nextjs-auth0/client";

const ExtraAttention = ({ 
  contributePanelVisible, 
  setContributePanelVisible,
  setSignupOpen,
}) => {
  const { user } = useUser();

  return (
    <>
      <div className="bg-yellow-50 border border-yellow-100 flex items-start mb-4 mx-4 p-4 rounded">
        <div className="relative pr-56">
          <div className="flex items-start">
            <IconInfo
              className="flex-shrink-0 mr-4 text-yellow-400"
              width="20"
            />
            <div>
              <strong className="font-semibold">
                This case needs attention
              </strong>
              <p className="mt-1 text-sm">
                Our goal is to crowdsource the more than 200,000 unsolved cases
                of the murdered and missing. Help us add more information to
                this case.{" "}
                {!user ? (
                  <Link href="/join">
                    <a className="font-semibold text-yellow-500 hover:text-yellow-700">
                      Click here to join us
                    </a>
                  </Link>
                ) : (
                  <></>
                )}
              </p>
            </div>
          </div>
          {!user ? (
            <Button
              onClick={() => setSignupOpen(true)}
              className="bg-yellow-400 rounded-md mt-7 font-bold text-white py-2 px-5 text-sm absolute top-0 right-0"
            >
              Contribute to this Case
            </Button>
          ) : (
            <Button
              className="bg-yellow-400 rounded-md mt-7 font-bold text-white py-2 px-3 text-sm absolute top-0 right-0"
              type="button"
              onClick={() => setContributePanelVisible(!contributePanelVisible)}
            >
              Contribute to this Case
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default ExtraAttention;
